/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedUsersRouteImport } from './routes/_authed.users'
import { Route as AuthedSemanticsRouteImport } from './routes/_authed.semantics'
import { Route as AuthedSearchTermsRouteImport } from './routes/_authed.search-terms'
import { Route as AuthedPipeRouteImport } from './routes/_authed.pipe'
import { Route as AuthedOverviewRouteImport } from './routes/_authed.overview'
import { Route as AuthedMemoryRouteImport } from './routes/_authed.memory'
import { Route as AuthedCompetitorsRouteImport } from './routes/_authed.competitors'
import { Route as AuthedCampaignsRouteImport } from './routes/_authed.campaigns'
import { Route as AuthedAntifraudRouteImport } from './routes/_authed.antifraud'
import { Route as AuthedAnomaliesRouteImport } from './routes/_authed.anomalies'
import { Route as AuthedAiRouteImport } from './routes/_authed.ai'
import { Route as AuthedSeoIndexRouteImport } from './routes/_authed.seo.index'
import { Route as AuthedSeoTasksRouteImport } from './routes/_authed.seo.tasks'
import { Route as AuthedSeoPositionsRouteImport } from './routes/_authed.seo.positions'
import { Route as AuthedSeoMeasureRouteImport } from './routes/_authed.seo.measure'
import { Route as AuthedSeoKeywordMapRouteImport } from './routes/_authed.seo.keyword-map'
import { Route as AuthedSeoContentRouteImport } from './routes/_authed.seo.content'
import { Route as AuthedSeoCompetitorsRouteImport } from './routes/_authed.seo.competitors'
import { Route as AuthedSeoAuditsRouteImport } from './routes/_authed.seo.audits'
import { Route as AuthedDealsIdRouteImport } from './routes/_authed.deals.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSemanticsRoute = AuthedSemanticsRouteImport.update({
  id: '/semantics',
  path: '/semantics',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSearchTermsRoute = AuthedSearchTermsRouteImport.update({
  id: '/search-terms',
  path: '/search-terms',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPipeRoute = AuthedPipeRouteImport.update({
  id: '/pipe',
  path: '/pipe',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOverviewRoute = AuthedOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMemoryRoute = AuthedMemoryRouteImport.update({
  id: '/memory',
  path: '/memory',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCompetitorsRoute = AuthedCompetitorsRouteImport.update({
  id: '/competitors',
  path: '/competitors',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCampaignsRoute = AuthedCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAntifraudRoute = AuthedAntifraudRouteImport.update({
  id: '/antifraud',
  path: '/antifraud',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnomaliesRoute = AuthedAnomaliesRouteImport.update({
  id: '/anomalies',
  path: '/anomalies',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAiRoute = AuthedAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSeoIndexRoute = AuthedSeoIndexRouteImport.update({
  id: '/seo/',
  path: '/seo/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSeoTasksRoute = AuthedSeoTasksRouteImport.update({
  id: '/seo/tasks',
  path: '/seo/tasks',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSeoPositionsRoute = AuthedSeoPositionsRouteImport.update({
  id: '/seo/positions',
  path: '/seo/positions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSeoMeasureRoute = AuthedSeoMeasureRouteImport.update({
  id: '/seo/measure',
  path: '/seo/measure',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSeoKeywordMapRoute = AuthedSeoKeywordMapRouteImport.update({
  id: '/seo/keyword-map',
  path: '/seo/keyword-map',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSeoContentRoute = AuthedSeoContentRouteImport.update({
  id: '/seo/content',
  path: '/seo/content',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSeoCompetitorsRoute = AuthedSeoCompetitorsRouteImport.update({
  id: '/seo/competitors',
  path: '/seo/competitors',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSeoAuditsRoute = AuthedSeoAuditsRouteImport.update({
  id: '/seo/audits',
  path: '/seo/audits',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDealsIdRoute = AuthedDealsIdRouteImport.update({
  id: '/deals/$id',
  path: '/deals/$id',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/ai': typeof AuthedAiRoute
  '/anomalies': typeof AuthedAnomaliesRoute
  '/antifraud': typeof AuthedAntifraudRoute
  '/campaigns': typeof AuthedCampaignsRoute
  '/competitors': typeof AuthedCompetitorsRoute
  '/memory': typeof AuthedMemoryRoute
  '/overview': typeof AuthedOverviewRoute
  '/pipe': typeof AuthedPipeRoute
  '/search-terms': typeof AuthedSearchTermsRoute
  '/semantics': typeof AuthedSemanticsRoute
  '/users': typeof AuthedUsersRoute
  '/deals/$id': typeof AuthedDealsIdRoute
  '/seo/audits': typeof AuthedSeoAuditsRoute
  '/seo/competitors': typeof AuthedSeoCompetitorsRoute
  '/seo/content': typeof AuthedSeoContentRoute
  '/seo/keyword-map': typeof AuthedSeoKeywordMapRoute
  '/seo/measure': typeof AuthedSeoMeasureRoute
  '/seo/positions': typeof AuthedSeoPositionsRoute
  '/seo/tasks': typeof AuthedSeoTasksRoute
  '/seo/': typeof AuthedSeoIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/ai': typeof AuthedAiRoute
  '/anomalies': typeof AuthedAnomaliesRoute
  '/antifraud': typeof AuthedAntifraudRoute
  '/campaigns': typeof AuthedCampaignsRoute
  '/competitors': typeof AuthedCompetitorsRoute
  '/memory': typeof AuthedMemoryRoute
  '/overview': typeof AuthedOverviewRoute
  '/pipe': typeof AuthedPipeRoute
  '/search-terms': typeof AuthedSearchTermsRoute
  '/semantics': typeof AuthedSemanticsRoute
  '/users': typeof AuthedUsersRoute
  '/deals/$id': typeof AuthedDealsIdRoute
  '/seo/audits': typeof AuthedSeoAuditsRoute
  '/seo/competitors': typeof AuthedSeoCompetitorsRoute
  '/seo/content': typeof AuthedSeoContentRoute
  '/seo/keyword-map': typeof AuthedSeoKeywordMapRoute
  '/seo/measure': typeof AuthedSeoMeasureRoute
  '/seo/positions': typeof AuthedSeoPositionsRoute
  '/seo/tasks': typeof AuthedSeoTasksRoute
  '/seo': typeof AuthedSeoIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/ai': typeof AuthedAiRoute
  '/_authed/anomalies': typeof AuthedAnomaliesRoute
  '/_authed/antifraud': typeof AuthedAntifraudRoute
  '/_authed/campaigns': typeof AuthedCampaignsRoute
  '/_authed/competitors': typeof AuthedCompetitorsRoute
  '/_authed/memory': typeof AuthedMemoryRoute
  '/_authed/overview': typeof AuthedOverviewRoute
  '/_authed/pipe': typeof AuthedPipeRoute
  '/_authed/search-terms': typeof AuthedSearchTermsRoute
  '/_authed/semantics': typeof AuthedSemanticsRoute
  '/_authed/users': typeof AuthedUsersRoute
  '/_authed/deals/$id': typeof AuthedDealsIdRoute
  '/_authed/seo/audits': typeof AuthedSeoAuditsRoute
  '/_authed/seo/competitors': typeof AuthedSeoCompetitorsRoute
  '/_authed/seo/content': typeof AuthedSeoContentRoute
  '/_authed/seo/keyword-map': typeof AuthedSeoKeywordMapRoute
  '/_authed/seo/measure': typeof AuthedSeoMeasureRoute
  '/_authed/seo/positions': typeof AuthedSeoPositionsRoute
  '/_authed/seo/tasks': typeof AuthedSeoTasksRoute
  '/_authed/seo/': typeof AuthedSeoIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/ai'
    | '/anomalies'
    | '/antifraud'
    | '/campaigns'
    | '/competitors'
    | '/memory'
    | '/overview'
    | '/pipe'
    | '/search-terms'
    | '/semantics'
    | '/users'
    | '/deals/$id'
    | '/seo/audits'
    | '/seo/competitors'
    | '/seo/content'
    | '/seo/keyword-map'
    | '/seo/measure'
    | '/seo/positions'
    | '/seo/tasks'
    | '/seo/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/ai'
    | '/anomalies'
    | '/antifraud'
    | '/campaigns'
    | '/competitors'
    | '/memory'
    | '/overview'
    | '/pipe'
    | '/search-terms'
    | '/semantics'
    | '/users'
    | '/deals/$id'
    | '/seo/audits'
    | '/seo/competitors'
    | '/seo/content'
    | '/seo/keyword-map'
    | '/seo/measure'
    | '/seo/positions'
    | '/seo/tasks'
    | '/seo'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/_authed/ai'
    | '/_authed/anomalies'
    | '/_authed/antifraud'
    | '/_authed/campaigns'
    | '/_authed/competitors'
    | '/_authed/memory'
    | '/_authed/overview'
    | '/_authed/pipe'
    | '/_authed/search-terms'
    | '/_authed/semantics'
    | '/_authed/users'
    | '/_authed/deals/$id'
    | '/_authed/seo/audits'
    | '/_authed/seo/competitors'
    | '/_authed/seo/content'
    | '/_authed/seo/keyword-map'
    | '/_authed/seo/measure'
    | '/_authed/seo/positions'
    | '/_authed/seo/tasks'
    | '/_authed/seo/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/semantics': {
      id: '/_authed/semantics'
      path: '/semantics'
      fullPath: '/semantics'
      preLoaderRoute: typeof AuthedSemanticsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/search-terms': {
      id: '/_authed/search-terms'
      path: '/search-terms'
      fullPath: '/search-terms'
      preLoaderRoute: typeof AuthedSearchTermsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pipe': {
      id: '/_authed/pipe'
      path: '/pipe'
      fullPath: '/pipe'
      preLoaderRoute: typeof AuthedPipeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/overview': {
      id: '/_authed/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof AuthedOverviewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/memory': {
      id: '/_authed/memory'
      path: '/memory'
      fullPath: '/memory'
      preLoaderRoute: typeof AuthedMemoryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/competitors': {
      id: '/_authed/competitors'
      path: '/competitors'
      fullPath: '/competitors'
      preLoaderRoute: typeof AuthedCompetitorsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/campaigns': {
      id: '/_authed/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AuthedCampaignsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/antifraud': {
      id: '/_authed/antifraud'
      path: '/antifraud'
      fullPath: '/antifraud'
      preLoaderRoute: typeof AuthedAntifraudRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/anomalies': {
      id: '/_authed/anomalies'
      path: '/anomalies'
      fullPath: '/anomalies'
      preLoaderRoute: typeof AuthedAnomaliesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ai': {
      id: '/_authed/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AuthedAiRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/seo/': {
      id: '/_authed/seo/'
      path: '/seo'
      fullPath: '/seo/'
      preLoaderRoute: typeof AuthedSeoIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/seo/tasks': {
      id: '/_authed/seo/tasks'
      path: '/seo/tasks'
      fullPath: '/seo/tasks'
      preLoaderRoute: typeof AuthedSeoTasksRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/seo/positions': {
      id: '/_authed/seo/positions'
      path: '/seo/positions'
      fullPath: '/seo/positions'
      preLoaderRoute: typeof AuthedSeoPositionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/seo/measure': {
      id: '/_authed/seo/measure'
      path: '/seo/measure'
      fullPath: '/seo/measure'
      preLoaderRoute: typeof AuthedSeoMeasureRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/seo/keyword-map': {
      id: '/_authed/seo/keyword-map'
      path: '/seo/keyword-map'
      fullPath: '/seo/keyword-map'
      preLoaderRoute: typeof AuthedSeoKeywordMapRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/seo/content': {
      id: '/_authed/seo/content'
      path: '/seo/content'
      fullPath: '/seo/content'
      preLoaderRoute: typeof AuthedSeoContentRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/seo/competitors': {
      id: '/_authed/seo/competitors'
      path: '/seo/competitors'
      fullPath: '/seo/competitors'
      preLoaderRoute: typeof AuthedSeoCompetitorsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/seo/audits': {
      id: '/_authed/seo/audits'
      path: '/seo/audits'
      fullPath: '/seo/audits'
      preLoaderRoute: typeof AuthedSeoAuditsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/deals/$id': {
      id: '/_authed/deals/$id'
      path: '/deals/$id'
      fullPath: '/deals/$id'
      preLoaderRoute: typeof AuthedDealsIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAiRoute: typeof AuthedAiRoute
  AuthedAnomaliesRoute: typeof AuthedAnomaliesRoute
  AuthedAntifraudRoute: typeof AuthedAntifraudRoute
  AuthedCampaignsRoute: typeof AuthedCampaignsRoute
  AuthedCompetitorsRoute: typeof AuthedCompetitorsRoute
  AuthedMemoryRoute: typeof AuthedMemoryRoute
  AuthedOverviewRoute: typeof AuthedOverviewRoute
  AuthedPipeRoute: typeof AuthedPipeRoute
  AuthedSearchTermsRoute: typeof AuthedSearchTermsRoute
  AuthedSemanticsRoute: typeof AuthedSemanticsRoute
  AuthedUsersRoute: typeof AuthedUsersRoute
  AuthedDealsIdRoute: typeof AuthedDealsIdRoute
  AuthedSeoAuditsRoute: typeof AuthedSeoAuditsRoute
  AuthedSeoCompetitorsRoute: typeof AuthedSeoCompetitorsRoute
  AuthedSeoContentRoute: typeof AuthedSeoContentRoute
  AuthedSeoKeywordMapRoute: typeof AuthedSeoKeywordMapRoute
  AuthedSeoMeasureRoute: typeof AuthedSeoMeasureRoute
  AuthedSeoPositionsRoute: typeof AuthedSeoPositionsRoute
  AuthedSeoTasksRoute: typeof AuthedSeoTasksRoute
  AuthedSeoIndexRoute: typeof AuthedSeoIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAiRoute: AuthedAiRoute,
  AuthedAnomaliesRoute: AuthedAnomaliesRoute,
  AuthedAntifraudRoute: AuthedAntifraudRoute,
  AuthedCampaignsRoute: AuthedCampaignsRoute,
  AuthedCompetitorsRoute: AuthedCompetitorsRoute,
  AuthedMemoryRoute: AuthedMemoryRoute,
  AuthedOverviewRoute: AuthedOverviewRoute,
  AuthedPipeRoute: AuthedPipeRoute,
  AuthedSearchTermsRoute: AuthedSearchTermsRoute,
  AuthedSemanticsRoute: AuthedSemanticsRoute,
  AuthedUsersRoute: AuthedUsersRoute,
  AuthedDealsIdRoute: AuthedDealsIdRoute,
  AuthedSeoAuditsRoute: AuthedSeoAuditsRoute,
  AuthedSeoCompetitorsRoute: AuthedSeoCompetitorsRoute,
  AuthedSeoContentRoute: AuthedSeoContentRoute,
  AuthedSeoKeywordMapRoute: AuthedSeoKeywordMapRoute,
  AuthedSeoMeasureRoute: AuthedSeoMeasureRoute,
  AuthedSeoPositionsRoute: AuthedSeoPositionsRoute,
  AuthedSeoTasksRoute: AuthedSeoTasksRoute,
  AuthedSeoIndexRoute: AuthedSeoIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
